import BobtailModal from './BobtailModal';
import DispatchErrorBody from './DispatchErrorBody';
import GwiEquipmentModal from './GwiEquipmentModal';
import UnitAssignmentModal from './UnitAssignmentModal';
import WaitingTimeModal from './WaitingTimeModal';

export {
  BobtailModal,
  DispatchErrorBody,
  GwiEquipmentModal,
  UnitAssignmentModal,
  WaitingTimeModal,
};

export const dispatchingModals = {
  GWI_EQUIPMENT_MODAL: GwiEquipmentModal,
  WAITING_TIME_MODAL: WaitingTimeModal,
  BOBTAIL_MODAL: BobtailModal,
};
